import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { ButtonText, GoogleSignInDiv, ImageWrapper } from './GoogleLoginButton.styles';
import { Image } from 'foundations-components/transitional/components/Image';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
// @ts-expect-error not converted to TS
import Images from 'LoginUI/images/imageUrls';
import FormattedMessage from 'I18n/components/FormattedMessage';

// const isIframed = () => {
//   try {
//     return window.self !== window.top;
//   } catch (e) {
//     return false;
//   }
// };
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const GoogleLoginButton = ({
  onClick,
  smartLogin,
  disabled,
  tooltipDisabled = true
}) => {
  return /*#__PURE__*/_jsx(Tooltip, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "login.smartLogin.disabledButtonHelp"
    }),
    disabled: tooltipDisabled,
    children: /*#__PURE__*/_jsxs(GoogleSignInDiv, {
      smartLogin: smartLogin,
      disabled: disabled
      // target={isIframed() ? '_blank' : '_self'} //- TODO: do we need this? I believe it works for type=link and not for type=button
      ,
      onClick: onClick,
      "data-test-id": "google-sign-in",
      children: [/*#__PURE__*/_jsx(ImageWrapper, {
        smartLogin: smartLogin,
        disabled: disabled,
        children: /*#__PURE__*/_jsx(Image, {
          height: 22,
          width: 22,
          src: Images.googleLogo
        })
      }), /*#__PURE__*/_jsx(ButtonText, {
        children: smartLogin ? /*#__PURE__*/_jsx(FormattedMessage, {
          message: "login.form.connected"
        }) : /*#__PURE__*/_jsx(TruncateString, {
          reverse: true,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "login.form.connected"
          })
        })
      })]
    })
  });
};
export default GoogleLoginButton;